module.exports = __webpack_public_path__ + "static/img/sjzz72.825cbaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjzz72.jpg
// module id = mQ6z
// module chunks = 73